import { Directive, ElementRef, Input, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';

@Directive({
  selector: 'img[domSrc]'
})
export class GetLanguageDirective {
  @Input() listLang: any;
  @Input() domSrc: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed
    if (changes['listLang']) {
      if(this.domSrc){
        let langue = _.find(this.listLang, ['code',this.domSrc]);
        if(langue){
          this.renderer.setAttribute(this.el.nativeElement,"src",langue.flag);
          this.renderer.setAttribute(this.el.nativeElement,"title",langue.name);
        }
      }
    }
  }
}